// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { DocsStep, type Zap } from '@zapier/product-get-help';

import { selectZapServices } from 'app/get-help/selectors';
import { withAllServicesById } from 'app/service/components/WithAllServicesById';

import type { ServicesMap } from 'app/service/types';
import type { State } from 'app/common/types';

type Doc = {
  href: string,
  title: string,
};

type DocsContainerProps = {
  services: ServicesMap,
  title: string,
  docs?: Doc[],
  body: ComponentType<*> | string,
  size: 'small' | 'medium' | 'large',
  zap?: Zap,
};

type App = {
  name: string,
  id: string,
  slug: string,
};

type DocsStepProps = {
  title: string,
  children: ComponentType<*> | string,
  docs?: Doc[],
  apps?: App[],
  size: 'small' | 'medium' | 'large',
};

const mapStateToProps = (
  state: State,
  props: DocsContainerProps
): DocsStepProps => {
  const { title, body, docs, services, size } = props;
  const apps = selectZapServices(props.zap, services);
  return {
    title,
    children: body,
    docs,
    apps,
    size,
  };
};

const DocsContainer = _.flowRight(
  withAllServicesById,
  connect(mapStateToProps)
)(DocsStep);

export default DocsContainer;
